<div class="card">
   <app-filter-container
      *ngIf="filters.length"
      [filters]="filters"
      [defaultFilterApplied]="defaultSelectedFilters"
      (appliedFilters)="loadCall($event.origin, $event.filters)"
      class="mb-2"
   ></app-filter-container>

   <!-- LOADING TABLE SKELETON -->
   <div *ngIf="loading()">
      <p-table [value]="[{}, {}, {}, {}, {}, {}, {}, {}]">
         <ng-template pTemplate="header">
            <tr>
               <th>Customer</th>
               <th>Phone Number</th>
               <th>Status</th>
               <th>Conversation Result</th>
               <th>Detalles</th>
               <th>Audio Actions</th>
               <th>Created At</th>
            </tr>
         </ng-template>
         <ng-template pTemplate="body" let-row>
            <tr>
               <td><p-skeleton width="80px"></p-skeleton></td>
               <td><p-skeleton width="120px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
               <td><p-skeleton width="80px"></p-skeleton></td>
               <td><p-skeleton width="120px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
            </tr>
         </ng-template>
      </p-table>
   </div>

   <!-- DATA TABLE -->
   <p-table
      *ngIf="outboundCalls().length && !loading()"
      [value]="outboundCalls()"
      [loading]="loading()"
      [rows]="10"
      responsiveLayout="scroll"
   >
      <ng-template pTemplate="header">
         <tr>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.CUSTOMER' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.PHONE_NUMBER' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.STATUS' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.CONVERSATION_RESULT' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.TRANSCRIPTION' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.AUDIO_ACTIONS' | translate }}</th>
            <th>{{ 'DATA.MODULES.CUSTOMERS.PAGES.CUSTOMER_LIST.FORM.CALL_TIME' | translate }}</th>
         </tr>
      </ng-template>

      <ng-template pTemplate="body" let-call>
         <tr>
            <td>
               <div class="flex flex-row gap-2 align-items-center">
                  <p-button
                     [pTooltip]="'Copia external id de la llamada'"
                     (onClick)="copyExternalId(call.externalId)"
                     icon="pi pi-copy"
                     [text]="true"
                     severity="secondary"
                     outlined="false"
                  />
                  <a
                     class="underline cursor-pointer text-primary align-items-center"
                     routerLink="{{ '/customers/customer/' + call.customer.id }}"
                     [queryParamsHandling]="'preserve'"
                  >
                     {{ call.customer.name | ellipsis: 30 }}
                  </a>
               </div>
            </td>
            <td><p-chip [label]="call.phoneNumber"></p-chip></td>
            <td>
               <app-custom-tag
                  [status]="call.status.toUpperCase()"
                  [value]="'DATA.COMMON.STATUS.' + call.status | translate"
               />
            </td>
            <td>
               <ng-container *ngIf="!!call.conversationResult; else noName">
                  {{ call.conversationResult }}
               </ng-container>
               <ng-template #noName>
                  <p class="font-italic text-gray-400">No hay resultados</p>
               </ng-template>
            </td>
            <td>
               <ng-container *ngIf="!!call.conversationResult; else noTrans">
                  <p-button
                     *ngIf="call.status != 'failed' && call.transcription && call?.transcription?.length > 0"
                     (click)="openAudioDialog(call)"
                     size="small"
                     severity="secondary"
                     icon="pi pi-eye"
                     [label]="'DATA.MODULES.CUSTOMERS.PAGES.ACTIVITIES.LABEL.SHOW_CALL' | translate"
                  ></p-button>
               </ng-container>
               <ng-template #noTrans>
                  <p *ngIf="call.status != 'failed'" class="font-italic text-gray-400">No hay resultados</p>
               </ng-template>

               <p *ngIf="call.status == 'failed'" class="font-italic text-red-400">
                  <i class="pi pi-ban"></i> {{ call.failedReason }}
               </p>
            </td>
            <td>
               <ng-container *ngIf="call.status == 'completed'; else noAction">
                  <p-button
                     [icon]="
                        loadingAudioCalls[call.id]
                           ? 'pi pi-spin pi-spinner'
                           : playingCallId() === call.id
                             ? 'pi pi-pause'
                             : 'pi pi-play'
                     "
                     size="small"
                     severity="secondary"
                     [text]="playingCallId() !== call.id"
                     [label]="playingCallId() === call.id ? formatTime(currentTimeMap[call.id] || 0) : ''"
                     (click)="playCallAudio(call)"
                  ></p-button>

                  <p-button
                     [icon]="loadingDownloads[call.id] ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                     severity="secondary"
                     text="true"
                     styleClass="ml-2"
                     size="small"
                     (click)="downloadCallAudio(call)"
                  ></p-button>
               </ng-container>
               <ng-template #noAction>
                  <p class="font-italic text-gray-400">No hay resultados</p>
               </ng-template>
            </td>
            <td>{{ call.createdAt | timezoneDate: true }}</td>
         </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
         <tr>
            <td class="p-d-flex p-align-center p-justify-center" colspan="9">
               {{ 'DATA.MODULES.OPERATIONS.PAGES.OPERATION_LIST.TABLE.MORE.NO_RESULTS' | translate }}
            </td>
         </tr>
      </ng-template>
   </p-table>

   <div
      *ngIf="!loading() && this.outboundCalls().length == 0"
      class="spinner-container text-center align-content-center mt-8 h-27rem"
   >
      <div class="text-900 font-bold text-6xl mb-4">
         {{ 'DATA.MODULES.OUTBOUNDCALL.NO_DATA' | translate }}
      </div>
      <div class="text-400 font-semibold text-xl mb-4">
         {{ 'DATA.MODULES.OUTBOUNDCALL.NO_DATA_DESC' | translate }}
      </div>
   </div>

   <div class="grid gap-2 w-full mt-4">
      <div class="col text-center flex justify-content-start w-full align-items-center gap-2">
         <span class="text-500 text-sm">Resultados totales:</span>
         <span class="font-semibold text-sm text-700">{{ totalResults() }}</span>
      </div>

      <div class="col text-center flex justify-center w-full align-items-center justify-content-center gap-3">
         <!-- Extract to comp. on second use -->
         <p-button
            severity="primary"
            icon="pi pi-angle-left"
            [disabled]="loading() || currentPage() === 1"
            styleClass="p-button-text"
            (click)="loadCall(SearchOrigin.LOAD_PREV, facade.lastCriteria())"
         ></p-button>
         <p-button type="button" icon="pi pi-refresh" (onClick)="resetCalls()" styleClass="p-button-text" />
         <p-button
            severity="primary"
            type="button"
            icon="pi pi-angle-right"
            [disabled]="loading() || !hasMore()"
            styleClass="p-button-text"
            (click)="loadCall(SearchOrigin.LOAD_NEXT, facade.lastCriteria())"
         ></p-button>
      </div>

      <div class="col text-center flex justify-content-end w-full align-items-center gap-2">
         <span class="text-500 text-sm">Resultados por página:</span>
         <p-button
            *ngFor="let size of [10, 25, 50, 100]"
            label="{{ size }}"
            (onClick)="setPageSize(size)"
            [rounded]="true"
            severity="secondary"
            size="small"
            [outlined]="facade.numResultsDisplayed() !== size"
         ></p-button>
      </div>
   </div>

   <p-confirmPopup>
      <ng-template pTemplate="content" let-message>
         <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border p-3 mb-3">
            <i [class]="message.icon" class="text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
         </div>
      </ng-template>
   </p-confirmPopup>
</div>

<p-toast></p-toast>

<!-- TODO: Extract -->
<p-dialog
   [(visible)]="isAudioDialogVisible"
   [modal]="true"
   [dismissableMask]="true"
   [style]="{ width: '80%', height: '90%', borderRadius: '12px', overflow: 'hidden' }"
   (onHide)="onAudioDialogHide()"
>
   <ng-template pTemplate="header">
      <div class="flex justify-content-between align-items-center mb-3 gap-3">
         <div class="icon-square">
            <i class="pi pi-phone text-indigo-700 text-lg"></i>
         </div>
         <div class="text-2xl text-800 font-semibold">
            Llamada a {{ selectedCallAudio?.customer?.name }} el día {{ selectedCallAudio?.createdAt | timezoneDate }}
         </div>
      </div>
   </ng-template>

   <div class="flex flex-row gap-2">
      <app-call-transcription-dialog
         [(visible)]="isAudioDialogVisible"
         [transcription]="selectedTranscription"
         [customerName]="selectedCustomerName"
         class="transcription-panel"
      ></app-call-transcription-dialog>

      <p-divider layout="vertical"></p-divider>

      <div class="audio-panel">
         <!-- Waveform Section -->
         <div class="flex flex-column align-items-center gap-3">
            <p-skeleton
               *ngIf="isWaveformLoading()"
               height="100px"
               width="100%"
               class="w-full"
               borderRadius="12px"
               styleClass="mb-2"
            ></p-skeleton>
            <div
               class="waveform-wrapper p-3"
               [style.display]="isWaveformLoading() ? 'none' : 'block'"
               [style.overflow]="isWaveformLoading() ? 'hidden' : 'visible'"
            >
               <div id="waveform" style="width: 100%; height: 80px"></div>
               <div id="wave-timeline" style="width: 100%; height: 20px"></div>
            </div>

            <!-- Playback Controls -->
            <div class="flex flex-row align-items-center justify-content-center gap-3 mt-2 w-full">
               <div class="flex-1">
                  <a [href]="selectedAudioUrl" download="call_audio.wav">
                     <p-button icon="pi pi-download" [severity]="'secondary'" [label]="'Descargar audio'"></p-button>
                  </a>
               </div>
               <div class="flex flex-row gap-2 align-items-center">
                  <p-button icon="pi pi-step-backward" (click)="skipBackward(5)" text></p-button>
                  <p-button
                     size="large"
                     [icon]="isPlaying ? 'pi pi-pause' : 'pi pi-play'"
                     (click)="togglePlayPause()"
                     [rounded]="true"
                     styleClass="margin"
                  ></p-button>
                  <p-button icon="pi pi-step-forward" (click)="skipForward(5)" text></p-button>
               </div>

               <div class="flex-1 gap-1 flex justify-content-end">
                  <p-button
                     label="0.5x"
                     (click)="setSpeed(0.5)"
                     [text]="playbackRate !== 0.5"
                     severity="secondary"
                  ></p-button>
                  <p-button
                     label="1x"
                     (click)="setSpeed(1)"
                     [text]="playbackRate !== 1"
                     severity="secondary"
                  ></p-button>
                  <p-button
                     label="2x"
                     (click)="setSpeed(1.5)"
                     [text]="playbackRate !== 1.5"
                     severity="secondary"
                  ></p-button>
               </div>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="call-info-container bg-indigo-50 border-round p-3 gap-2">
            <span class="text-indigo-700 font-semibold">{{ 'DATA.MODULES.OUTBOUNDCALL.DETAILS' | translate }}</span>

            <div class="call-info-grid mt-3 ml-2">
               <div class="call-info-item" *ngIf="selectedCallAudio?.id">
                  <div class="icon-square">
                     <i class="pi pi-hashtag text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.CALL_ID' | translate }}</span>
                     <span class="value">{{ selectedCallAudio?.externalId }} </span>
                  </div>
               </div>

               <div class="call-info-item" *ngIf="selectedCallAudio?.phoneNumber">
                  <div class="icon-square">
                     <i class="pi pi-phone text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.PHONE_NUMBER' | translate }}</span>
                     <span class="value">{{ selectedCallAudio?.phoneNumber }}</span>
                  </div>
               </div>

               <div class="call-info-item">
                  <div class="icon-square">
                     <i class="pi pi-clock text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.DURATION' | translate }}</span>
                     <span class="value">{{ selectedCallAudio?.duration }}s</span>
                  </div>
               </div>

               <div class="call-info-item">
                  <div class="icon-square">
                     <i class="pi pi-calendar text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.DATETIME' | translate }}</span>
                     <span class="value">{{ selectedCallAudio?.createdAt | timezoneDate: true }}</span>
                  </div>
               </div>

               <div class="call-info-item">
                  <div class="icon-square">
                     <i class="pi pi-user-minus text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.CLOSED_BY' | translate }}</span>
                     <span class="value">{{ selectedCallAudio?.closedBy ?? '-' }}</span>
                  </div>
               </div>

               <div class="call-info-item">
                  <div class="icon-square">
                     <i class="pi pi-arrow-right-arrow-left text-indigo-700 text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="label">{{ 'DATA.MODULES.OUTBOUNDCALL.TRANSFERRED' | translate }}</span>
                     <span class="value">{{ selectedCallAudio?.transferred ? 'Sí' : 'No' }}</span>
                  </div>
               </div>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex flex-column gap-2 bg-blue-50 border-round p-3">
            <span class="text-blue-700 font-semibold mb-2">{{ 'DATA.MODULES.OUTBOUNDCALL.RESUME' | translate }}</span>
            <div class="text-600 ml-2" *ngFor="let line of structuredSummary">• {{ line }}</div>
         </div>
         <p-divider></p-divider>

         <div class="tags-container border-round p-3 gap-2">
            <span class="text-700 font-semibold">{{ 'DATA.MODULES.OUTBOUNDCALL.TAGS' | translate }}</span>

            <div class="flex flex-wrap gap-3 mt-3 ml-2">
               <div
                  class="tag-card flex align-items-center gap-2 p-2 pr-3 border-round bg-bluegray-50 shadow-1"
                  *ngFor="let tag of selectedCallAudio?.tags ?? {} | keyvalue"
               >
                  <div class="icon-square2">
                     <i class="pi pi-tag text-lg"></i>
                  </div>
                  <div class="text-column">
                     <span class="label text-800 font-semibold">{{ tag.key | titlecase }}</span>
                     <span class="value text-600">{{ tag.value }}</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</p-dialog>
